import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import css from 'styled-jsx/css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

const { className: modalClass, styles: modalStyles } = css.resolve`
  @media (max-width: 767px) {
    .modal-dialog {
      margin: 0;
    }
  }
`;

const { className: contentClass, styles: contentStyles } = css.resolve`
  .modal-content {
    height: 100%;
    border-radius: 0;
  }
  @media (min-width: 768px) {
    .modal-content {
      height: 50%;
      border-radius: 1rem;
    }
  }
`;

export default function AssetUpdateModal(props) {
  const { isOpen, toggleModal, handleSubmitUpdate, updatePending, updating } =
    props;

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggleModal}
      size="md"
      centered
      className={modalClass}
      contentClassName={contentClass}
    >
      <ModalHeader className="border-bottom-0 font-weight-medium text-text-dark">
        There are available updates for your Gateway
      </ModalHeader>
      <ModalBody className="text-muted text-center position-relative nine-tenth-text">
        <p className="mb-3">
          Updating your Gateway will take your asset offline. Please check this
          page again in about 20 minutes to see if the update was successful.
        </p>
        <button
          className={`btn ${
            updating ? 'btn-icon-link-gray' : 'modal-button-submit'
          } mt-2 py-0 px-5 px-md-3 text-white nine-tenth-text`}
          onClick={handleSubmitUpdate}
        >
          {updatePending ? (
            <FontAwesomeIcon icon={faCircleNotch} spin />
          ) : updating ? (
            'Gateway Update In Progress'
          ) : (
            'Update Gateway Now'
          )}
        </button>
      </ModalBody>
      <ModalFooter className="border-top-0">
        <button
          className="btn btn-outline-secondary py-0 px-4 nine-tenth-text ml-4"
          onClick={toggleModal}
        >
          Close
        </button>
      </ModalFooter>
      {modalStyles}
      {contentStyles}
    </Modal>
  );
}

AssetUpdateModal.propTypes = {
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
  updatePending: PropTypes.bool,
  handleSubmitUpdate: PropTypes.func,
  updating: PropTypes.bool,
};
